import { PurchaseItem, PurchaseItemGuestStatus } from "types";
import { useConfirmationModal } from "./useConfirmationModal";
import { PostCheckInWarningModal } from "@/components/PurchasesMenu/PostCheckInWarningModal";

export const usePostCheckinWarningModal = (purchaseItem?: PurchaseItem) => {
    const { ConfirmationModal, withConfirmation, confirm } = useConfirmationModal(
        PostCheckInWarningModal,
        shouldShowCheckInWarning(purchaseItem),
    );

    return {
        PostCheckInWarningModal: ConfirmationModal,
        confirmPostCheckInWarning: confirm,
        withPostCheckInWarning: withConfirmation,
    };
};

const shouldShowCheckInWarning = (item?: PurchaseItem) => {
    if (!item?.guestStatus) {
        return false;
    }

    return (
        item.guestStatus === PurchaseItemGuestStatus.ARRIVED ||
        item.guestStatus === PurchaseItemGuestStatus.PARTIALLY_ARRIVED
    );
};
